export type ControlEnvelope={callId:string;from:string;packet:unknown};
const listeners=new Set<(packet:ControlEnvelope)=>void>();
export function dispatchRemoteControl(value:unknown){
  const v=value as Partial<ControlEnvelope>|null;
  if(!v||typeof v.callId!=='string'||typeof v.from!=='string'||!v.packet)return;
  listeners.forEach(listener=>listener(v as ControlEnvelope));
}
export function subscribeRemoteControl(listener:(packet:ControlEnvelope)=>void){listeners.add(listener);return()=>{listeners.delete(listener);};}

